<micro-lookup domain="db2sms" obj="db2SmsConfigs" url="/db2sms/db2SmsConfigs" [key]="configId" [link]="link"></micro-lookup>
